<template>
  <div class="task-todo-list">
    <div class="task-todo-item" v-for="(item, index) in list" :key="index">
      <div class="d-flex align-items-center">
        <div
          class="task-todo-item-circle"
          :class="{ checked: !!item.billNo }"
        ></div>
        <div class="task-todo-item-text">
          <span>{{ `${item.todoName}` }}</span>
          <span v-if="item.billNo">{{ ' - ' }}</span>
          <span
            v-if="item.billNo"
            class="task-todo-item-link"
            @click="query(item)"
          >
            {{ item.billNo }}
          </span>
        </div>
      </div>
      <div>
        <el-button
          size="mini"
          plain
          v-if="!item.billNo && !disabled"
          @click="create(item)"
        >
          {{ $l('btn_createTodo') || '立即处理' }}
        </el-button>
        <el-button
          size="mini"
          plain
          v-if="item.billNo"
          @click="query(item)"
        >
          {{ $l('btn_viewTodo') || '查看' }}
        </el-button>
      </div>
    </div>

    <TodoView
      :visible.sync="todoViewOpts.visible"
      :tskInfoNo="todoViewOpts.tskInfoNo"
      :todoTypeKey="todoViewOpts.todoTypeKey"
      :title="todoViewOpts.title"
      :billNo="todoViewOpts.billNo"
      @reload="reload"
    />
  </div>
</template>

<script>
import TodoView from './todo-view'
export default {
  components: { TodoView },
  props: {
    tskInfoCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      list: [],
      todoViewOpts: {
        visible: false,
        tskInfoNo: '',
        todoTypeKey: '',
        title: '',
        billNo: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    reload() {
      this.getData()
      this.$emit('reload')
    },
    async getData() {
      if (!this.tskInfoCode) return
      const res = await this.$api
        .personalTskTodoListApi({ tskInfoCode: this.tskInfoCode })
        .catch(() => null)
      if (!res) return
      this.list = res.body?.data || []
    },
    create({ tskInfoNo, todoTypeKey, todoName }) {
      this.todoViewOpts = {
        visible: true,
        tskInfoNo,
        todoTypeKey,
        title: todoName,
      }
    },
    query({ billNo, todoTypeKey, todoName }) {
      this.todoViewOpts = {
        visible: true,
        billNo,
        todoTypeKey,
        title: todoName,
      }
    },
    replaceUrl(url, data) {
      if (!url) return ''
      return url.replace(/\{(\w+)\}/g, (match, placeholder) => {
        return data[placeholder] || match
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.task-todo-list {
  .task-todo-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    font-size: 14px;
    .task-todo-item-circle {
      border: 1px solid #dce0e7;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      margin-right: 14px;
    }
    .task-todo-item-circle.checked {
      background-image: url(./todo-checked.png);
      background-position: center center;
      background-size: 24px 24px;
      border: none;
    }
    .task-todo-item-link {
      cursor: pointer;
      color: #248cf9;
      text-decoration: underline;
    }
    .el-button {
      width: 80px;
      background-color: #f4f9ff;
      border-radius: 5px !important;
      border: none;
      font-size: 12px;
      color: #101010;
    }
  }
}
</style>
